import { Mapper } from "../../../../base/utils/mapper";
import { ActivityDailyPhysiotherapyModel } from "../../../../domain/models/consult/activity-daily.model";
import { ActivityDailyPhysiotherapyEntity } from "../entities/activity-daily.entity";

export class ActivityDailyPhysiotherapyImplementationRepositoryMapper extends Mapper<ActivityDailyPhysiotherapyEntity, ActivityDailyPhysiotherapyModel> {
    mapFrom(param: ActivityDailyPhysiotherapyEntity): ActivityDailyPhysiotherapyModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ActivityDailyPhysiotherapyModel): ActivityDailyPhysiotherapyEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}